export const getOptionId = (value) => `option-id-${value}`;
export const defaultRenderOption = ({ option }) => option.label;
export const defaultRenderOptionLabel = (option) => option.label;
